/* global window:true */
/* global $:true */

import React, { Component, PropTypes } from 'react';
import Helmet from 'react-helmet';
import ReactGA from 'react-ga';
import _ from 'underscore';
import { capitalize } from 'underscore.string';
import lockr from 'lockr';
import { browserHistory } from 'react-router';

import Loading from '../components/Loading';
import ResourceItem from '../components/ResourceItem';
import ResourcesExplained from '../components/ResourcesExplained';
import JoyrideWrapper from '../elements/JoyrideWrapper';

const TITLE = 'Resources';

const {
    INTRO_DONE
} = require('../core/constants').default;

const joyrideSteps = [
    {
        title: 'Here’s your bookshelf',
        text: 'Here you can find digital files of all the books and the associated teaching resources.',
        selector: '#resource-2',
        position: 'top',
        type: 'hover'
    }, {
        title: 'Learn more here',
        text: 'Here’s where you explore the Clever Tykes story, as well as further information on enterprise education and our sponsor.',
        selector: 'h1#more-resources',
        position: 'bottom',
        type: 'hover'
    }, {
        title: 'Don’t forget!',
        text: 'We want to hear from you! Use this link to tell us how your students have enjoyed the books.',
        selector: '#feedback',
        position: 'bottom',
        type: 'hover'
    }, {
        title: 'Take it further',
        text: 'Use this option to book a date for your school’s enterprise education session.',
        selector: 'li#book-session',
        position: 'bottom',
        type: 'hover'
    }, {
        title: 'Get started!',
        text: 'Five ways you can get the Clever Tykes books straight into your teaching today!',
        selector: '#resource-4',
        position: 'bottom',
        type: 'hover'
    }
];

class ResourcesListPage extends Component {
    componentDidMount() {
        const { actions } = this.props;

        // set breadcrumb
        actions.setBreadcrumb([{ title: TITLE }]);

        // load resources
        actions.resourcesRequest();
        actions.categoriesRequest();

        // log analytics
        ReactGA.pageview(window.location.pathname);

        setTimeout(() => {
            $('.portfolio-filter li').on('click', function () {
                $('.portfolio-filter li').removeClass('active');
                $(this).addClass('active');

                const selector = $(this).attr('data-filter');
                $('.gallery ').isotope({
                    filter: selector,
                });
            });
        }, 1200);
    }

    handleCallback = (response) => {
        if (response.type === 'finished') {
            lockr.set(INTRO_DONE, true);
        }
    };

    render() {
        const { resources, resourcesState, profile } = this.props;
        // console.log('resources', resources);

        if (resourcesState.isFetching && resources.length === 0) {
            return <Loading />;
        }

        // if (!profile.isProfileCompleted && lockr.get(INTRO_DONE)) {
        //     // redirect to profile complete page
        //     browserHistory.push('/profile/update');
        // }

        if (!profile.emailVerified) {
            // redirect to not verified
            browserHistory.push('/not-active');
        }

        const categoriesPluck = _.pluck(resources, 'category');
        const categories = categoriesPluck.filter((elem, index, self) => index === self.indexOf(elem));

        return (
            <div className="portfolio-wrapper index-1">
                <Helmet title={TITLE} />
                {!lockr.get(INTRO_DONE) ? <JoyrideWrapper steps={joyrideSteps} callback={this.handleCallback} /> : null }
                <div className="section-name index-1 container">
                    <div className="col-md-12 resources-title">
                        <h1>Books and resources</h1>
                        <ul className="portfolio-filter">
                            <li data-filter="*" className="active"><i className="fa fa-chevron-right" />All</li>
                            {categories.map((category, index) => <li key={index} data-filter={`.${category}`}><i className="fa fa-chevron-right" />{capitalize(category)}</li>)}
                        </ul>
                        <div className="sep" />
                    </div>
                </div>

                <div className="portfolio-main container" style={{ marginBottom: '80px' }}>
                    <div className="gallery row">
                        {resources.length === 0 ?
                            <p>No books found</p>
                            :
                                resources.map(resource => <ResourceItem key={resource.id} resource={resource} />
                        )}
                    </div>
                </div>

                <ResourcesExplained />
            </div>
        );
    }
}

ResourcesListPage.propTypes = {
    actions: PropTypes.object,
    resourcesState: PropTypes.object,
    resources: PropTypes.array,
    profile: PropTypes.object
};

export default ResourcesListPage;



/** WEBPACK FOOTER **
 ** ./src/pages/ResourcesListPage.js
 **/